var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-popup-background",on:{"click":function($event){return _vm.closePopup($event)}}},[_c('div',{staticClass:"copy-popup"},[_c('div',{staticClass:"image-holder"},[_c('img',{attrs:{"src":this.image.href}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }